import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FaUsers, FaHandshake, FaLeaf } from 'react-icons/fa';
import { fadeInUp, staggerContainer, enhancedViewport } from '../../utils/animation';
import './AboutTeam.scss';

const AboutTeam = () => {
  const { t } = useTranslation('about');
  const values = t('team.values', { returnObjects: true });
  const icons = [<FaUsers />, <FaHandshake />, <FaLeaf />];
  
  // OPTIMIZAT: Eliminat useAnimation() și useEffect() overhead - folosim whileInView direct
  return (
    <section className="about-team">
      <div className="container">
        <motion.h2
          className="about-team__title"
          initial="hidden"
          whileInView="visible"
          viewport={enhancedViewport}
          variants={fadeInUp}
        >
          {t('team.title')}
        </motion.h2>
        
        <motion.p
          className="about-team__intro"
          initial="hidden"
          whileInView="visible"
          viewport={enhancedViewport}
          variants={fadeInUp}
        >
          {t('team.intro')}
        </motion.p>
        <motion.div
          className="about-team__values"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={enhancedViewport}
        >
          {values.map((value, index) => (
            <motion.div key={index} className="about-team__value-card" variants={fadeInUp}>
              <div className="about-team__icon">
                {icons[index]}
              </div>
              <h3 className="about-team__value-title">{value.title}</h3>
              <p className="about-team__value-description">
                {value.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default AboutTeam;
